import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useWallet } from '@solana/wallet-adapter-react'
import { useWalletModal } from '@solana/wallet-adapter-react-ui'

// next components
import { useRouter } from 'next/router'

// components

// custom functions

// json
import PrintType from 'assets/json/wallart/print.json'
import OrientType from 'assets/json/wallart/orientation.json'
import SizeType from 'assets/json/wallart/size.json'

// images
import SolanaLogoIcon from 'assets/icons/solana-logo-dark.svg?component'
import ArrowLeftIcon from 'assets/icons/arrow-left-24x24.svg?component'

// styles
import styles from './index.module.scss'
import Selection from 'components/Selection'
import WalletTag from './WalletTag'
import NftImageEditorModal from 'components/Modal/NftImageEditorModal'
import { useSolToUsdRate } from 'hooks/useSolToUsdRate'
import WallSection from '../WallSection'
import QuantityCard from 'components/Card/QuantityCard'
import PrimaryButton from 'components/Button/PrimaryButton'
import SecondaryButton from 'components/Button/SecondaryButton'
import Alert from 'components/Alert'
import GradientButton from 'components/Button/GradientButton'
import OutlineButton from 'components/Button/OutlineButton'

// api

const WallArtDetail = props => {
  const { onBack, onPrint, onShipping, onAddCart, subCategory, data, setData, nftName, nftImage, nftCoverUrl } = props
  const router = useRouter()
  const id = router.query.id
  const { connected } = useWallet()
  const { setVisible } = useWalletModal()
  const dispatch = useDispatch()
  const { solToUsdRate } = useSolToUsdRate()
  const [print, setPrint] = useState({ name: '', type: '', image: '' })
  const [orientation, setOrientation] = useState(OrientType[0])
  const [size, setSize] = useState({ width: 1, height: 1, price: '' })
  const [sizes, setSizes] = useState([])
  const [quantity, setQuantity] = useState(1)
  const [enabled, setEnabled] = useState(false)
  const [cost, setCost] = useState('----')
  const [openEditorModal, setOpenEditorModal] = useState(false)
  const [cropImage, setCropImage] = useState(null)
  const [previewSection, setPreviewSection] = useState(null)
  const [finishEditing, setFinishEditing] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [alertData, setAlertData] = useState<any[]>([])
  const isAddToCartWallArt = useSelector(state => (state as any).isAddToCartWallArt)
  const printImageUrl = useSelector<any>(state => state.printImageUrl)

  const wallartName = useMemo(() => {
    if (subCategory === 'poster') return 'Matte Paper Poster'
    else if (subCategory === 'canvas') return 'Canvas'
    else if (subCategory === 'metal') return 'Glossy Metal Print'
    else return 'Luster Photo Paper'
  }, [subCategory])

  useEffect(() => {
    window.scrollTo({
      top: 0,
    })
  }, [])

  useEffect(() => {
    if (subCategory.length > 0) {
      let print = PrintType.filter(item => item.type === subCategory)
      setPrint(print[0])
    }
  }, [subCategory])

  useEffect(() => {
    if (data !== null) {
      setPrint(data.print)
      setOrientation(data.orientation)

      let sizeAll = SizeType.filter(item => item.type === data.print.type)[0]
      let sizes = []
      sizes = sizeAll[data.orientation.type].map(
        item => (item = { ...item, selected: item.id === data.size.id ? true : false })
      )
      setSize(data.size)
      setSizes(sizes)
      setQuantity(data.quantity)
      setCost(data.cost)
      setCropImage(data.cropImage)
      setEnabled(true)
      setTimeout(() => {
        setData(null)
      }, 2000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    if (data !== null) return

    setEnabled(false)
    if (print.hasOwnProperty('id')) {
      setCost('----')
      setOrientation(OrientType[0])
      setCropImage(null)
      let sizeAll = SizeType.filter(item => item.type === print.type)[0]
      let sizes = []
      sizes = sizeAll[OrientType[0].type].map(item => (item = { ...item, selected: false }))

      let selectedSize = subCategory === 'poster' ? sizes[1] : sizes[0]
      setSize(selectedSize)

      let newSizes = [...sizes]
      newSizes.map(element => {
        if (element.id === selectedSize.id) {
          element.selected = true
        } else {
          element.selected = false
        }
      })

      setSizes(newSizes)
      setOpenEditorModal(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [print])

  useEffect(() => {
    if (data !== null) return

    setEnabled(false)
    if (print.hasOwnProperty('id') && orientation.hasOwnProperty('id')) {
      let sizeAll = SizeType.filter(item => item.type === print.type)[0]
      let sizes = []
      sizes = sizeAll[orientation.type].map(item => (item = { ...item, selected: false }))
      setSizes(sizes)
      setCost('----')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orientation])

  useEffect(() => {
    if (data !== null) return

    if (print.hasOwnProperty('id')) {
      setEnabled(true)
      setCost(size.price)
    }

    if (quantity <= 0) {
      setEnabled(false)
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size])

  useEffect(() => {
    if (data !== null) return

    if (quantity <= 0) {
      setEnabled(false)
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  const setSelectSize = item => {
    setSize(item)

    let newSizes = [...sizes]
    newSizes.map(element => {
      if (element.id === item.id) {
        element.selected = true
      } else {
        element.selected = false
      }
    })

    setSizes(newSizes)
    setOpenEditorModal(true)
  }

  const moveShippingPage = () => {
    let data = { print, orientation, sizes, size, quantity, cost, cropImage }
    onShipping(data)
    setPrint({ name: '', type: '', image: '' })
    setOrientation(OrientType[0])
  }

  const handleSaveData = () => {
    if (!connected) {
      setVisible(true)
      return
    }

    if (!previewSection) return

    let data = { print, orientation, size, quantity, cost }

    onAddCart(data)
    setAlertData([
      {
        id: 0,
        title: 'Item added to cart',
        description: `You've successfully added ${wallartName} to your shopping cart.`,
        type: 'success',
      },
    ])
    setShowAlert(true)
  }

  useEffect(() => {
    if (printImageUrl && isAddToCartWallArt) {
      let existingData = JSON.parse(localStorage.getItem('cart_v1')) || []
      if (!Array.isArray(existingData)) {
        existingData = []
      }

      let data = {
        version: 'v1',
        print,
        size,
        quantity,
        cost,
        id,
        nftCoverUrl,
        nftName,
        printImageUrl,
      }
      existingData.push(data)

      localStorage.setItem('cart_v1', JSON.stringify(existingData))
      dispatch({ type: 'set', isAddToCartWallArt: false })
      dispatch({ type: 'set', printImageUrl: null })
      dispatch({ type: 'set', cartUpdated: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printImageUrl, isAddToCartWallArt])

  return (
    <section className={styles.container}>
      <div className="lg:hidden block">
        <div className={styles.wallartBG}>
          <div className="absolute inset-0 w-full h-full"></div>
          <WallSection
            canvasId="wallart-mobile"
            type={subCategory}
            nftName={nftName}
            wallArt={previewSection}
            finishEditing={finishEditing}
          />
        </div>
      </div>
      <div className="flex gap-[15px] mt-[20px] lg:mt-[20px] items-center">
        <div onClick={onBack}>
          <ArrowLeftIcon />
        </div>
        <div className={styles.selecteCategory}>{wallartName}</div>
      </div>
      <div className={styles.description}>
        {subCategory === 'poster'
          ? 'Choose the orientation, pick the print size, and select the quantity. This print is crafted on premium 10.3 mil stock—weighing in at 189 g/m². Sourced straight from Japan.'
          : subCategory === 'canvas'
          ? 'Choose the orientation, pick the print size, and select the quantity. This print is crafted on textured and fade-resistant canvas—weighing in at 344 g/m² with 1.25" thickness.'
          : subCategory === 'metal'
          ? 'Choose the orientation, pick the print size, and select the quantity. Printed on a glossy aluminum surface using sublimation with additional coating for true color replication. Scratch-resistant, fade-proof. Ships to the USA only.'
          : 'Choose the orientation, pick the print size, and select the quantity. This print is crafted on premium 10 mil stock—weighing in at 260 g/m². Slightly glossy and fingerprint-resistant. Sourced straight from Japan.'}
      </div>

      <div className="w-full mt-[45px]">
        <Selection
          label="Orientation"
          data={OrientType}
          selected={orientation?.name}
          onSelect={item => setOrientation(item)}
        />
      </div>

      <div className="w-full mt-[30px]">
        <div className={styles.selectSize}>{'Size'}</div>
        <div className="w-full flex flex-wrap gap-[15px] mt-[15px]">
          {sizes.map((item, index) => (
            <div key={index}>
              <WalletTag
                item={item}
                setSelect={item => {
                  setSelectSize(item)
                }}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="w-full mt-[30px]">
        <div className={styles.quantity}>Quantity</div>
        <div className="mt-[15px]">
          <QuantityCard
            qty={quantity}
            onMinus={() => {
              if (quantity > 1) setQuantity(quantity - 1)
            }}
            onPlus={() => {
              setQuantity(quantity + 1)
            }}
          />
        </div>
      </div>

      <div className="lg:hidden block">
        <div className="w-full mt-[25px] flex items-center">
          <div className="flex gap-[10px] items-center">
            <SolanaLogoIcon alt="" />
            <div className={styles.price}>
              {cost === '----' ? '----' : ((parseFloat(cost) * quantity) / solToUsdRate).toFixed(2)}
            </div>
          </div>
          <div className={styles.separator}></div>
          <div className={styles.price}>$ {cost === '----' ? '----' : (parseFloat(cost) * quantity).toFixed(2)}</div>
        </div>

        <div className="w-full mt-[30px] flex-wrap flex gap-[15px] mb-[30px]">
          <GradientButton
            disabled={!enabled}
            label="Buy Now"
            fullWidth
            onClick={() => {
              if (cropImage === null) {
                setOpenEditorModal(true)
              } else {
                moveShippingPage()
              }
            }}
          />
          <OutlineButton label="Add to Cart" onClick={() => handleSaveData()} fullWidth />
        </div>
      </div>

      <div className="mt-[40px] w-full lg:block hidden">
        <div className="w-full mt-[25px] flex">
          <div className="flex items-center">
            <div className="flex gap-[10px] items-center">
              <SolanaLogoIcon alt="" />
              <div className={styles.solPrice}>
                {cost === '----' ? '----' : ((parseFloat(cost) * quantity) / solToUsdRate).toFixed(2)}
              </div>
            </div>
            <div className={styles.separator}></div>
            <div className={styles.price}>$ {cost === '----' ? '----' : (parseFloat(cost) * quantity).toFixed(2)}</div>
          </div>
        </div>
        <div className="w-full flex flex-wrap mt-[20px] pb-[30px] gap-[15px]">
          <GradientButton
            disabled={!enabled}
            label="Buy Now"
            fullWidth
            onClick={() => {
              if (cropImage === null) {
                setOpenEditorModal(true)
              } else {
                moveShippingPage()
              }
            }}
          />
          <OutlineButton label="Add to Cart" onClick={() => handleSaveData()} fullWidth />
        </div>
      </div>
      <NftImageEditorModal
        style={{ zIndex: 100001 }}
        open={openEditorModal}
        close={() => setOpenEditorModal(false)}
        nftUrl={[nftImage]}
        getCroppedImage={croppedImage => {
          setCropImage(croppedImage)
          setOpenEditorModal(false)
          let image = { art: croppedImage, wall: print.image, size: size }
          onPrint(image)
          setPreviewSection(image)
          setFinishEditing(true)
        }}
        dimension={{ value: [1080, (1080 * size.height) / size.width] }}
      />

      <Alert
        open={showAlert}
        close={() => {
          setShowAlert(false)
        }}
        data={alertData}
      />
    </section>
  )
}

export default WallArtDetail
